import enTranslations from '../locales/en.json';
import faTranslations from '../locales/fa.json';

const translations = {
  en: enTranslations,
  fa: faTranslations
};

/**
 * Get translation for a given key
 * @param {string} key - Translation key (e.g., 'common.save')
 * @param {string} language - Language code ('en' or 'fa')
 * @returns {string} - Translated string
 */
export const getTranslation = (key, language = 'fa') => {
  const keys = key.split('.');
  let translation = translations[language];

  for (const k of keys) {
    if (translation && translation[k]) {
      translation = translation[k];
    } else {
      // Fallback to English if key not found
      translation = translations['en'];
      for (const fallbackKey of keys) {
        if (translation && translation[fallbackKey]) {
          translation = translation[fallbackKey];
        } else {
          return key; // Return key itself if not found
        }
      }
      break;
    }
  }

  return translation;
};

/**
 * Get all translations for a language
 * @param {string} language - Language code ('en' or 'fa')
 * @returns {object} - All translations
 */
export const getAllTranslations = (language = 'fa') => {
  return translations[language] || translations['en'];
};

/**
 * Check if a translation key exists
 * @param {string} key - Translation key
 * @param {string} language - Language code
 * @returns {boolean}
 */
export const hasTranslation = (key, language = 'fa') => {
  const keys = key.split('.');
  let translation = translations[language];

  for (const k of keys) {
    if (translation && translation[k]) {
      translation = translation[k];
    } else {
      return false;
    }
  }

  return true;
};

export default { getTranslation, getAllTranslations, hasTranslation };
